'use strict';

function NotifyMeForm(props) {
  const [inputs, setInputs] = React.useState({});
  const [country, setCountry] = React.useState('US');
  const [submit, setSubmit] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [validPhone, setValidPhone] = React.useState({
    check: false,
    valid: true
  });
  React.useEffect(() => {
    if (validPhone.check) {
      if (!inputs.hasOwnProperty('phone')) {
        setValidPhone(prevState => ({
          ...prevState,
          valid: false
        }));
        setSubmit(false);
      } else {
        if (!inputs.phone.match(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
          setValidPhone(prevState => ({
            ...prevState,
            valid: false
          }));
          setSubmit(false);
        } else {
          setValidPhone(prevState => ({
            ...prevState,
            valid: true
          }));
        }
      }
    }
  }, [inputs]);
  React.useEffect(() => {
    if (validPhone.valid && validPhone.check) {
      setSubmit(true);
    } else {
      setSubmit(false);
    }
  }, [validPhone]);
  const handleChange = event => {
    const inputValue = event.target.value;
    const inputName = event.target.name;
    if (inputName == 'phone') {
      setValidPhone(prevState => ({
        ...prevState,
        check: true
      }));
    }
    setInputs(prevState => ({
      ...prevState,
      [inputName]: inputValue
    }));
  };
  const handleCountry = event => {
    setCountry(event.target.value);
  };
  const handleSubmit = event => {
    event.preventDefault();
    console.log(country);
    let countryCodes = {
      "US": "+1",
      "CA": "+1",
      "AU": "+61",
      "GB": "+44",
      "AF": "+93",
      "AL": "+355",
      "DZ": "+213",
      "AS": "+1",
      "AD": "+376",
      "AO": "+244",
      "AI": "+1",
      "AG": "+1",
      "AR": "+54",
      "AM": "+374",
      "AW": "+297",
      "AT": "+43",
      "AZ": "+994",
      "BH": "+973",
      "BD": "+880",
      "BB": "+1",
      "BY": "+375",
      "BE": "+32",
      "BZ": "+501",
      "BJ": "+229",
      "BM": "+1",
      "BT": "+975",
      "BO": "+591",
      "BA": "+387",
      "BW": "+267",
      "BR": "+55",
      "IO": "+246",
      "VG": "+1",
      "BN": "+673",
      "BG": "+359",
      "BF": "+226",
      "MM": "+95",
      "BI": "+257",
      "KH": "+855",
      "CM": "+237",
      "CV": "+238",
      "KY": "+1",
      "CF": "+236",
      "TD": "+235",
      "CL": "+56",
      "CN": "+86",
      "CO": "+57",
      "KM": "+269",
      "CK": "+682",
      "CR": "+506",
      "HR": "+385",
      "CU": "+53",
      "CY": "+357",
      "CZ": "+420",
      "CD": "+243",
      "DK": "+45",
      "DJ": "+253",
      "DM": "+1",
      "DO": "+1",
      "EC": "+593",
      "EG": "+20",
      "SV": "+503",
      "GQ": "+240",
      "ER": "+291",
      "EE": "+372",
      "ET": "+251",
      "FK": "+500",
      "FO": "+298",
      "FO": "+691",
      "FJ": "+679",
      "FI": "+358",
      "FR": "+33",
      "GF": "+594",
      "PF": "+689",
      "GA": "+241",
      "GE": "+995",
      "DE": "+49",
      "GH": "+233",
      "GI": "+350",
      "GR": "+30",
      "GL": "+299",
      "GD": "+1",
      "GP": "+590",
      "GU": "+1",
      "GT": "+502",
      "GN": "+224",
      "GW": "+245",
      "GY": "+592",
      "HT": "+509",
      "HN": "+504",
      "HK": "+852",
      "HU": "+36",
      "IS": "+354",
      "IN": "+91",
      "ID": "+62",
      "IR": "+98",
      "IQ": "+964",
      "IE": "+353",
      "IL": "+972",
      "IT": "+39",
      "CI": "+225",
      "JM": "+1",
      "JP": "+81",
      "JO": "+962",
      "KZ": "+997",
      "KE": "+254",
      "KI": "+686",
      "KW": "+965",
      "KG": "+996",
      "LA": "+856",
      "LV": "+371",
      "LB": "+961",
      "LS": "+266",
      "LR": "+231",
      "LY": "+218",
      "LI": "+423",
      "LT": "+370",
      "LU": "+352",
      "MO": "+853",
      "MK": "+389",
      "MG": "+261",
      "MW": "+265",
      "MY": "+60",
      "MV": "+960",
      "ML": "+223",
      "MT": "+356",
      "MH": "+692",
      "MQ": "+596",
      "MR": "+222",
      "MU": "+230",
      "MX": "+52",
      "MD": "+373",
      "MC": "+377",
      "MN": "+976",
      "ME": "+382",
      "MA": "+212",
      "MS": "+1",
      "MZ": "+258",
      "NA": "+264",
      "NR": "+674",
      "NP": "+977",
      "NL": "+31",
      "NC": "+687",
      "NZ": "+64",
      "NI": "+505",
      "NE": "+227",
      "NG": "+234",
      "NU": "+683",
      "NF": "+6723",
      "KP": "+850",
      "MP": "+1",
      "NO": "+47",
      "OM": "+968",
      "PK": "+92",
      "PW": "+680",
      "PS": "+970",
      "PA": "+507",
      "PG": "+675",
      "PY": "+595",
      "PE": "+51",
      "PH": "+63",
      "PL": "+48",
      "PT": "+351",
      "PR": "+1",
      "QA": "+974",
      "CG": "+243",
      "RE": "+262",
      "RO": "+40",
      "RU": "+7",
      "RW": "+250",
      "SH": "+290",
      "LC": "+1",
      "KN": "+1",
      "PM": "+508",
      "VC": "+1",
      "WS": "+685",
      "SM": "+378",
      "ST": "+239",
      "SA": "+966",
      "SN": "+221",
      "RS": "+381",
      "SC": "+248",
      "SL": "+232",
      "SG": "+65",
      "SK": "+421",
      "SI": "+386",
      "SB": "+677",
      "SO": "+252",
      "ZA": "+27",
      "KR": "+82",
      "SS": "+211",
      "ES": "+34",
      "LK": "+94",
      "SD": "+249",
      "SR": "+597",
      "SE": "+46",
      "CH": "+41",
      "SY": "+963",
      "TW": "+886",
      "TJ": "+992",
      "TZ": "+255",
      "TH": "+66",
      "BS": "+1",
      "GM": "+220",
      "TL": "+670",
      "TG": "+228",
      "TK": "+690",
      "TO": "+676",
      "TT": "+1",
      "TN": "+216",
      "TR": "+90",
      "TM": "+993",
      "TV": "+688",
      "TC": "+1",
      "UG": "+256",
      "UA": "+380",
      "AE": "+971",
      "UY": "+598",
      "UZ": "+998",
      "VU": "+678",
      "VA": "+39",
      "VE": "+58",
      "VN": "+84",
      "WF": "+681",
      "YE": "+967",
      "ZM": "+260",
      "ZW": "+263"
    };
    if (submit) {
      console.log(inputs.phone);
      console.log(inputs);
      fetch('https://tlf-server-2023-oxh3p.ondigitalocean.app/yotpo/new-subscriber', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "phone": countryCodes[country] + inputs.phone,
          "list_id": 7823609
        })
      }).then(response => {
        setSuccess(true);
      });
      setSuccess(true);
    }
  };
  if (success) {
    return /*#__PURE__*/React.createElement("div", {
      className: "thankyou"
    }, /*#__PURE__*/React.createElement("h1", null, "Thank You For Signing Up"));
  } else {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: "name-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "signupMessage"
    }, "Get Notified When It Drops"), /*#__PURE__*/React.createElement("div", {
      className: "phoneSection"
    }, /*#__PURE__*/React.createElement("select", {
      value: country,
      onChange: handleCountry
    }, /*#__PURE__*/React.createElement("option", {
      value: "US"
    }, "\uD83C\uDDFA\uD83C\uDDF8 United States"), /*#__PURE__*/React.createElement("option", {
      value: "CA"
    }, "\uD83C\uDDE8\uD83C\uDDE6 Canada"), /*#__PURE__*/React.createElement("option", {
      value: "AU"
    }, "\uD83C\uDDE6\uD83C\uDDFA Australia"), /*#__PURE__*/React.createElement("option", {
      value: "GB"
    }, "\uD83C\uDDEC\uD83C\uDDE7 United Kingdom"), /*#__PURE__*/React.createElement("option", {
      value: "AF"
    }, "\uD83C\uDDE6\uD83C\uDDEB Afghanistan"), /*#__PURE__*/React.createElement("option", {
      value: "AL"
    }, "\uD83C\uDDE6\uD83C\uDDF1 Albania"), /*#__PURE__*/React.createElement("option", {
      value: "DZ"
    }, "\uD83C\uDDE9\uD83C\uDDFF Algeria"), /*#__PURE__*/React.createElement("option", {
      value: "AS"
    }, "\uD83C\uDDE6\uD83C\uDDF8 American Samoa"), /*#__PURE__*/React.createElement("option", {
      value: "AD"
    }, "\uD83C\uDDE6\uD83C\uDDE9 Andorra"), /*#__PURE__*/React.createElement("option", {
      value: "AO"
    }, "\uD83C\uDDE6\uD83C\uDDF4 Angola"), /*#__PURE__*/React.createElement("option", {
      value: "AI"
    }, "\uD83C\uDDE6\uD83C\uDDEE Anguilla"), /*#__PURE__*/React.createElement("option", {
      value: "AG"
    }, "\uD83C\uDDE6\uD83C\uDDEC Antigua and Barbuda"), /*#__PURE__*/React.createElement("option", {
      value: "AR"
    }, "\uD83C\uDDE6\uD83C\uDDF7 Argentina"), /*#__PURE__*/React.createElement("option", {
      value: "AM"
    }, "\uD83C\uDDE6\uD83C\uDDF2 Armenia"), /*#__PURE__*/React.createElement("option", {
      value: "AW"
    }, "\uD83C\uDDE6\uD83C\uDDFC Aruba"), /*#__PURE__*/React.createElement("option", {
      value: "AT"
    }, "\uD83C\uDDE6\uD83C\uDDF9 Austria"), /*#__PURE__*/React.createElement("option", {
      value: "AZ"
    }, "\uD83C\uDDE6\uD83C\uDDFF Azerbaijan"), /*#__PURE__*/React.createElement("option", {
      value: "BH"
    }, "\uD83C\uDDE7\uD83C\uDDED Bahrain"), /*#__PURE__*/React.createElement("option", {
      value: "BD"
    }, "\uD83C\uDDE7\uD83C\uDDE9 Bangladesh"), /*#__PURE__*/React.createElement("option", {
      value: "BB"
    }, "\uD83C\uDDE7\uD83C\uDDE7 Barbados"), /*#__PURE__*/React.createElement("option", {
      value: "BY"
    }, "\uD83C\uDDE7\uD83C\uDDFE Belarus"), /*#__PURE__*/React.createElement("option", {
      value: "BE"
    }, "\uD83C\uDDE7\uD83C\uDDEA Belgium"), /*#__PURE__*/React.createElement("option", {
      value: "BZ"
    }, "\uD83C\uDDE7\uD83C\uDDFF Belize"), /*#__PURE__*/React.createElement("option", {
      value: "BJ"
    }, "\uD83C\uDDE7\uD83C\uDDEF Benin"), /*#__PURE__*/React.createElement("option", {
      value: "BM"
    }, "\uD83C\uDDE7\uD83C\uDDF2 Bermuda"), /*#__PURE__*/React.createElement("option", {
      value: "BT"
    }, "\uD83C\uDDE7\uD83C\uDDF9 Bhutan"), /*#__PURE__*/React.createElement("option", {
      value: "BO"
    }, "\uD83C\uDDE7\uD83C\uDDF4 Bolivia"), /*#__PURE__*/React.createElement("option", {
      value: "BA"
    }, "\uD83C\uDDE7\uD83C\uDDE6 Bosnia and Herzegovina"), /*#__PURE__*/React.createElement("option", {
      value: "BW"
    }, "\uD83C\uDDE7\uD83C\uDDFC Botswana"), /*#__PURE__*/React.createElement("option", {
      value: "BR"
    }, "\uD83C\uDDE7\uD83C\uDDF7 Brazil"), /*#__PURE__*/React.createElement("option", {
      value: "IO"
    }, "\uD83C\uDDEE\uD83C\uDDF4 British Indian Ocean Territory"), /*#__PURE__*/React.createElement("option", {
      value: "VG"
    }, "\uD83C\uDDFB\uD83C\uDDEC British Virgin Islands"), /*#__PURE__*/React.createElement("option", {
      value: "BN"
    }, "\uD83C\uDDE7\uD83C\uDDF3 Brunei"), /*#__PURE__*/React.createElement("option", {
      value: "BG"
    }, "\uD83C\uDDE7\uD83C\uDDEC Bulgaria"), /*#__PURE__*/React.createElement("option", {
      value: "BF"
    }, "\uD83C\uDDE7\uD83C\uDDEB Burkina Faso"), /*#__PURE__*/React.createElement("option", {
      value: "MM"
    }, "\uD83C\uDDF2\uD83C\uDDF2 Burma Myanmar"), /*#__PURE__*/React.createElement("option", {
      value: "BI"
    }, "\uD83C\uDDE7\uD83C\uDDEE Burundi"), /*#__PURE__*/React.createElement("option", {
      value: "KH"
    }, "\uD83C\uDDF0\uD83C\uDDED Cambodia"), /*#__PURE__*/React.createElement("option", {
      value: "CM"
    }, "\uD83C\uDDE8\uD83C\uDDF2 Cameroon"), /*#__PURE__*/React.createElement("option", {
      value: "CV"
    }, "\uD83C\uDDE8\uD83C\uDDFB Cape Verde"), /*#__PURE__*/React.createElement("option", {
      value: "KY"
    }, "\uD83C\uDDF0\uD83C\uDDFE Cayman Islands"), /*#__PURE__*/React.createElement("option", {
      value: "CF"
    }, "\uD83C\uDDE8\uD83C\uDDEB Central African Republic"), /*#__PURE__*/React.createElement("option", {
      value: "TD"
    }, "\uD83C\uDDF9\uD83C\uDDE9 Chad"), /*#__PURE__*/React.createElement("option", {
      value: "CL"
    }, "\uD83C\uDDE8\uD83C\uDDF1 Chile"), /*#__PURE__*/React.createElement("option", {
      value: "CN"
    }, "\uD83C\uDDE8\uD83C\uDDF3 China"), /*#__PURE__*/React.createElement("option", {
      value: "CO"
    }, "\uD83C\uDDE8\uD83C\uDDF4 Colombia"), /*#__PURE__*/React.createElement("option", {
      value: "KM"
    }, "\uD83C\uDDF0\uD83C\uDDF2 Comoros"), /*#__PURE__*/React.createElement("option", {
      value: "CK"
    }, "\uD83C\uDDE8\uD83C\uDDF0 Cook Islands"), /*#__PURE__*/React.createElement("option", {
      value: "CR"
    }, "\uD83C\uDDE8\uD83C\uDDF7 Costa Rica"), /*#__PURE__*/React.createElement("option", {
      value: "HR"
    }, "\uD83C\uDDED\uD83C\uDDF7 Croatia"), /*#__PURE__*/React.createElement("option", {
      value: "CU"
    }, "\uD83C\uDDE8\uD83C\uDDFA Cuba"), /*#__PURE__*/React.createElement("option", {
      value: "CY"
    }, "\uD83C\uDDE8\uD83C\uDDFE Cyprus"), /*#__PURE__*/React.createElement("option", {
      value: "CZ"
    }, "\uD83C\uDDE8\uD83C\uDDFF Czech Republic"), /*#__PURE__*/React.createElement("option", {
      value: "CD"
    }, "\uD83C\uDDE8\uD83C\uDDE9 Democratic Republic of Congo"), /*#__PURE__*/React.createElement("option", {
      value: "DK"
    }, "\uD83C\uDDE9\uD83C\uDDF0 Denmark"), /*#__PURE__*/React.createElement("option", {
      value: "DJ"
    }, "\uD83C\uDDE9\uD83C\uDDEF Djibouti"), /*#__PURE__*/React.createElement("option", {
      value: "DM"
    }, "\uD83C\uDDE9\uD83C\uDDF2 Dominica"), /*#__PURE__*/React.createElement("option", {
      value: "DO"
    }, "\uD83C\uDDE9\uD83C\uDDF4 Dominican Republic"), /*#__PURE__*/React.createElement("option", {
      value: "EC"
    }, "\uD83C\uDDEA\uD83C\uDDE8 Ecuador"), /*#__PURE__*/React.createElement("option", {
      value: "EG"
    }, "\uD83C\uDDEA\uD83C\uDDEC Egypt"), /*#__PURE__*/React.createElement("option", {
      value: "SV"
    }, "\uD83C\uDDF8\uD83C\uDDFB El Salvador"), /*#__PURE__*/React.createElement("option", {
      value: "GQ"
    }, "\uD83C\uDDEC\uD83C\uDDF6 Equatorial Guinea"), /*#__PURE__*/React.createElement("option", {
      value: "ER"
    }, "\uD83C\uDDEA\uD83C\uDDF7 Eritrea"), /*#__PURE__*/React.createElement("option", {
      value: "EE"
    }, "\uD83C\uDDEA\uD83C\uDDEA Estonia"), /*#__PURE__*/React.createElement("option", {
      value: "ET"
    }, "\uD83C\uDDEA\uD83C\uDDF9 Ethiopia"), /*#__PURE__*/React.createElement("option", {
      value: "FK"
    }, "\uD83C\uDDEB\uD83C\uDDF0 Falkland Islands"), /*#__PURE__*/React.createElement("option", {
      value: "FO"
    }, "\uD83C\uDDEB\uD83C\uDDF4 Faroe Islands"), /*#__PURE__*/React.createElement("option", {
      value: "FM"
    }, "\uD83C\uDDEB\uD83C\uDDF2 Federated States of Micronesia"), /*#__PURE__*/React.createElement("option", {
      value: "FJ"
    }, "\uD83C\uDDEB\uD83C\uDDEF Fiji"), /*#__PURE__*/React.createElement("option", {
      value: "FI"
    }, "\uD83C\uDDEB\uD83C\uDDEE Finland"), /*#__PURE__*/React.createElement("option", {
      value: "FR"
    }, "\uD83C\uDDEB\uD83C\uDDF7 France"), /*#__PURE__*/React.createElement("option", {
      value: "GF"
    }, "\uD83C\uDDEC\uD83C\uDDEB French Guiana"), /*#__PURE__*/React.createElement("option", {
      value: "PF"
    }, "\uD83C\uDDF5\uD83C\uDDEB French Polynesia"), /*#__PURE__*/React.createElement("option", {
      value: "GA"
    }, "\uD83C\uDDEC\uD83C\uDDE6 Gabon"), /*#__PURE__*/React.createElement("option", {
      value: "GE"
    }, "\uD83C\uDDEC\uD83C\uDDEA Georgia"), /*#__PURE__*/React.createElement("option", {
      value: "DE"
    }, "\uD83C\uDDE9\uD83C\uDDEA Germany"), /*#__PURE__*/React.createElement("option", {
      value: "GH"
    }, "\uD83C\uDDEC\uD83C\uDDED Ghana"), /*#__PURE__*/React.createElement("option", {
      value: "GI"
    }, "\uD83C\uDDEC\uD83C\uDDEE Gibraltar"), /*#__PURE__*/React.createElement("option", {
      value: "GR"
    }, "\uD83C\uDDEC\uD83C\uDDF7 Greece"), /*#__PURE__*/React.createElement("option", {
      value: "GL"
    }, "\uD83C\uDDEC\uD83C\uDDF1 Greenland"), /*#__PURE__*/React.createElement("option", {
      value: "GD"
    }, "\uD83C\uDDEC\uD83C\uDDE9 Grenada"), /*#__PURE__*/React.createElement("option", {
      value: "GP"
    }, "\uD83C\uDDEC\uD83C\uDDF5 Guadeloupe"), /*#__PURE__*/React.createElement("option", {
      value: "GU"
    }, "\uD83C\uDDEC\uD83C\uDDFA Guam"), /*#__PURE__*/React.createElement("option", {
      value: "GT"
    }, "\uD83C\uDDEC\uD83C\uDDF9 Guatemala"), /*#__PURE__*/React.createElement("option", {
      value: "GN"
    }, "\uD83C\uDDEC\uD83C\uDDF3 Guinea"), /*#__PURE__*/React.createElement("option", {
      value: "GW"
    }, "\uD83C\uDDEC\uD83C\uDDFC Guinea-Bissau"), /*#__PURE__*/React.createElement("option", {
      value: "GY"
    }, "\uD83C\uDDEC\uD83C\uDDFE Guyana"), /*#__PURE__*/React.createElement("option", {
      value: "HT"
    }, "\uD83C\uDDED\uD83C\uDDF9 Haiti"), /*#__PURE__*/React.createElement("option", {
      value: "HN"
    }, "\uD83C\uDDED\uD83C\uDDF3 Honduras"), /*#__PURE__*/React.createElement("option", {
      value: "HK"
    }, "\uD83C\uDDED\uD83C\uDDF0 Hong Kong"), /*#__PURE__*/React.createElement("option", {
      value: "HU"
    }, "\uD83C\uDDED\uD83C\uDDFA Hungary"), /*#__PURE__*/React.createElement("option", {
      value: "IS"
    }, "\uD83C\uDDEE\uD83C\uDDF8 Iceland"), /*#__PURE__*/React.createElement("option", {
      value: "IN"
    }, "\uD83C\uDDEE\uD83C\uDDF3 India"), /*#__PURE__*/React.createElement("option", {
      value: "ID"
    }, "\uD83C\uDDEE\uD83C\uDDE9 Indonesia"), /*#__PURE__*/React.createElement("option", {
      value: "IR"
    }, "\uD83C\uDDEE\uD83C\uDDF7 Iran"), /*#__PURE__*/React.createElement("option", {
      value: "IQ"
    }, "\uD83C\uDDEE\uD83C\uDDF6 Iraq"), /*#__PURE__*/React.createElement("option", {
      value: "IE"
    }, "\uD83C\uDDEE\uD83C\uDDEA Ireland"), /*#__PURE__*/React.createElement("option", {
      value: "IL"
    }, "\uD83C\uDDEE\uD83C\uDDF1 Israel"), /*#__PURE__*/React.createElement("option", {
      value: "IT"
    }, "\uD83C\uDDEE\uD83C\uDDF9 Italy"), /*#__PURE__*/React.createElement("option", {
      value: "CI"
    }, "\uD83C\uDDE8\uD83C\uDDEE Ivory Coast"), /*#__PURE__*/React.createElement("option", {
      value: "JM"
    }, "\uD83C\uDDEF\uD83C\uDDF2 Jamaica"), /*#__PURE__*/React.createElement("option", {
      value: "JP"
    }, "\uD83C\uDDEF\uD83C\uDDF5 Japan"), /*#__PURE__*/React.createElement("option", {
      value: "JO"
    }, "\uD83C\uDDEF\uD83C\uDDF4 Jordan"), /*#__PURE__*/React.createElement("option", {
      value: "KZ"
    }, "\uD83C\uDDF0\uD83C\uDDFF Kazakhstan"), /*#__PURE__*/React.createElement("option", {
      value: "KE"
    }, "\uD83C\uDDF0\uD83C\uDDEA Kenya"), /*#__PURE__*/React.createElement("option", {
      value: "KI"
    }, "\uD83C\uDDF0\uD83C\uDDEE Kiribati"), /*#__PURE__*/React.createElement("option", {
      value: "KW"
    }, "\uD83C\uDDF0\uD83C\uDDFC Kuwait"), /*#__PURE__*/React.createElement("option", {
      value: "KG"
    }, "\uD83C\uDDF0\uD83C\uDDEC Kyrgyzstan"), /*#__PURE__*/React.createElement("option", {
      value: "LA"
    }, "\uD83C\uDDF1\uD83C\uDDE6 Laos"), /*#__PURE__*/React.createElement("option", {
      value: "LV"
    }, "\uD83C\uDDF1\uD83C\uDDFB Latvia"), /*#__PURE__*/React.createElement("option", {
      value: "LB"
    }, "\uD83C\uDDF1\uD83C\uDDE7 Lebanon"), /*#__PURE__*/React.createElement("option", {
      value: "LS"
    }, "\uD83C\uDDF1\uD83C\uDDF8 Lesotho"), /*#__PURE__*/React.createElement("option", {
      value: "LR"
    }, "\uD83C\uDDF1\uD83C\uDDF7 Liberia"), /*#__PURE__*/React.createElement("option", {
      value: "LY"
    }, "\uD83C\uDDF1\uD83C\uDDFE Libya"), /*#__PURE__*/React.createElement("option", {
      value: "LI"
    }, "\uD83C\uDDF1\uD83C\uDDEE Liechtenstein"), /*#__PURE__*/React.createElement("option", {
      value: "LT"
    }, "\uD83C\uDDF1\uD83C\uDDF9 Lithuania"), /*#__PURE__*/React.createElement("option", {
      value: "LU"
    }, "\uD83C\uDDF1\uD83C\uDDFA Luxembourg"), /*#__PURE__*/React.createElement("option", {
      value: "MO"
    }, "\uD83C\uDDF2\uD83C\uDDF4 Macau"), /*#__PURE__*/React.createElement("option", {
      value: "MK"
    }, "\uD83C\uDDF2\uD83C\uDDF0 Macedonia"), /*#__PURE__*/React.createElement("option", {
      value: "MG"
    }, "\uD83C\uDDF2\uD83C\uDDEC Madagascar"), /*#__PURE__*/React.createElement("option", {
      value: "MW"
    }, "\uD83C\uDDF2\uD83C\uDDFC Malawi"), /*#__PURE__*/React.createElement("option", {
      value: "MY"
    }, "\uD83C\uDDF2\uD83C\uDDFE Malaysia"), /*#__PURE__*/React.createElement("option", {
      value: "MV"
    }, "\uD83C\uDDF2\uD83C\uDDFB Maldives"), /*#__PURE__*/React.createElement("option", {
      value: "ML"
    }, "\uD83C\uDDF2\uD83C\uDDF1 Mali"), /*#__PURE__*/React.createElement("option", {
      value: "MT"
    }, "\uD83C\uDDF2\uD83C\uDDF9 Malta"), /*#__PURE__*/React.createElement("option", {
      value: "MH"
    }, "\uD83C\uDDF2\uD83C\uDDED Marshall Islands"), /*#__PURE__*/React.createElement("option", {
      value: "MQ"
    }, "\uD83C\uDDF2\uD83C\uDDF6 Martinique"), /*#__PURE__*/React.createElement("option", {
      value: "MR"
    }, "\uD83C\uDDF2\uD83C\uDDF7 Mauritania"), /*#__PURE__*/React.createElement("option", {
      value: "MU"
    }, "\uD83C\uDDF2\uD83C\uDDFA Mauritius"), /*#__PURE__*/React.createElement("option", {
      value: "MX"
    }, "\uD83C\uDDF2\uD83C\uDDFD Mexico"), /*#__PURE__*/React.createElement("option", {
      value: "MD"
    }, "\uD83C\uDDF2\uD83C\uDDE9 Moldova"), /*#__PURE__*/React.createElement("option", {
      value: "MC"
    }, "\uD83C\uDDF2\uD83C\uDDE8 Monaco"), /*#__PURE__*/React.createElement("option", {
      value: "MN"
    }, "\uD83C\uDDF2\uD83C\uDDF3 Mongolia"), /*#__PURE__*/React.createElement("option", {
      value: "ME"
    }, "\uD83C\uDDF2\uD83C\uDDEA Montenegro"), /*#__PURE__*/React.createElement("option", {
      value: "MA"
    }, "\uD83C\uDDF2\uD83C\uDDE6 Morocco"), /*#__PURE__*/React.createElement("option", {
      value: "MS"
    }, "\uD83C\uDDF2\uD83C\uDDF8 Montserrat"), /*#__PURE__*/React.createElement("option", {
      value: "MZ"
    }, "\uD83C\uDDF2\uD83C\uDDFF Mozambique"), /*#__PURE__*/React.createElement("option", {
      value: "NA"
    }, "\uD83C\uDDF3\uD83C\uDDE6 Namibia"), /*#__PURE__*/React.createElement("option", {
      value: "NR"
    }, "\uD83C\uDDF3\uD83C\uDDF7 Nauru"), /*#__PURE__*/React.createElement("option", {
      value: "NP"
    }, "\uD83C\uDDF3\uD83C\uDDF5 Nepal"), /*#__PURE__*/React.createElement("option", {
      value: "NL"
    }, "\uD83C\uDDF3\uD83C\uDDF1 Netherlands"), /*#__PURE__*/React.createElement("option", {
      value: "NC"
    }, "\uD83C\uDDF3\uD83C\uDDE8 New Caledonia"), /*#__PURE__*/React.createElement("option", {
      value: "NZ"
    }, "\uD83C\uDDF3\uD83C\uDDFF New Zealand"), /*#__PURE__*/React.createElement("option", {
      value: "NI"
    }, "\uD83C\uDDF3\uD83C\uDDEE Nicaragua"), /*#__PURE__*/React.createElement("option", {
      value: "NE"
    }, "\uD83C\uDDF3\uD83C\uDDEA Niger"), /*#__PURE__*/React.createElement("option", {
      value: "NG"
    }, "\uD83C\uDDF3\uD83C\uDDEC Nigeria"), /*#__PURE__*/React.createElement("option", {
      value: "NU"
    }, "\uD83C\uDDF3\uD83C\uDDFA Niue"), /*#__PURE__*/React.createElement("option", {
      value: "NF"
    }, "\uD83C\uDDF3\uD83C\uDDEB Norfolk Island"), /*#__PURE__*/React.createElement("option", {
      value: "KP"
    }, "\uD83C\uDDF0\uD83C\uDDF5 North Korea"), /*#__PURE__*/React.createElement("option", {
      value: "MP"
    }, "\uD83C\uDDF2\uD83C\uDDF5 Northern Mariana Islands"), /*#__PURE__*/React.createElement("option", {
      value: "NO"
    }, "\uD83C\uDDF3\uD83C\uDDF4 Norway"), /*#__PURE__*/React.createElement("option", {
      value: "OM"
    }, "\uD83C\uDDF4\uD83C\uDDF2 Oman"), /*#__PURE__*/React.createElement("option", {
      value: "PK"
    }, "\uD83C\uDDF5\uD83C\uDDF0 Pakistan"), /*#__PURE__*/React.createElement("option", {
      value: "PW"
    }, "\uD83C\uDDF5\uD83C\uDDFC Palau"), /*#__PURE__*/React.createElement("option", {
      value: "PS"
    }, "\uD83C\uDDF5\uD83C\uDDF8 Palestine"), /*#__PURE__*/React.createElement("option", {
      value: "PA"
    }, "\uD83C\uDDF5\uD83C\uDDE6 Panama"), /*#__PURE__*/React.createElement("option", {
      value: "PG"
    }, "\uD83C\uDDF5\uD83C\uDDEC Papua New Guinea"), /*#__PURE__*/React.createElement("option", {
      value: "PY"
    }, "\uD83C\uDDF5\uD83C\uDDFE Paraguay"), /*#__PURE__*/React.createElement("option", {
      value: "PE"
    }, "\uD83C\uDDF5\uD83C\uDDEA Peru"), /*#__PURE__*/React.createElement("option", {
      value: "PH"
    }, "\uD83C\uDDF5\uD83C\uDDED Philippines"), /*#__PURE__*/React.createElement("option", {
      value: "PL"
    }, "\uD83C\uDDF5\uD83C\uDDF1 Poland"), /*#__PURE__*/React.createElement("option", {
      value: "PT"
    }, "\uD83C\uDDF5\uD83C\uDDF9 Portugal"), /*#__PURE__*/React.createElement("option", {
      value: "PR"
    }, "\uD83C\uDDF5\uD83C\uDDF7 Puerto Rico"), /*#__PURE__*/React.createElement("option", {
      value: "QA"
    }, "\uD83C\uDDF6\uD83C\uDDE6 Qatar"), /*#__PURE__*/React.createElement("option", {
      value: "CG"
    }, "\uD83C\uDDE8\uD83C\uDDEC Republic of the Congo"), /*#__PURE__*/React.createElement("option", {
      value: "RE"
    }, "\uD83C\uDDF7\uD83C\uDDEA R\xE9union"), /*#__PURE__*/React.createElement("option", {
      value: "RO"
    }, "\uD83C\uDDF7\uD83C\uDDF4 Romania"), /*#__PURE__*/React.createElement("option", {
      value: "RU"
    }, "\uD83C\uDDF7\uD83C\uDDFA Russia"), /*#__PURE__*/React.createElement("option", {
      value: "RW"
    }, "\uD83C\uDDF7\uD83C\uDDFC Rwanda"), /*#__PURE__*/React.createElement("option", {
      value: "SH"
    }, "\uD83C\uDDF8\uD83C\uDDED Saint Helena"), /*#__PURE__*/React.createElement("option", {
      value: "LC"
    }, "\uD83C\uDDF1\uD83C\uDDE8 Saint Lucia"), /*#__PURE__*/React.createElement("option", {
      value: "KN"
    }, "\uD83C\uDDF0\uD83C\uDDF3 Saint Kitts and Nevis"), /*#__PURE__*/React.createElement("option", {
      value: "PM"
    }, "\uD83C\uDDF5\uD83C\uDDF2 Saint Pierre and Miquelon"), /*#__PURE__*/React.createElement("option", {
      value: "VC"
    }, "\uD83C\uDDFB\uD83C\uDDE8 Saint Vincent and the Grenadines"), /*#__PURE__*/React.createElement("option", {
      value: "WS"
    }, "\uD83C\uDDFC\uD83C\uDDF8 Samoa"), /*#__PURE__*/React.createElement("option", {
      value: "SM"
    }, "\uD83C\uDDF8\uD83C\uDDF2 San Marino"), /*#__PURE__*/React.createElement("option", {
      value: "ST"
    }, "\uD83C\uDDF8\uD83C\uDDF9 S\xE3o Tom\xE9 and Pr\xEDncipe"), /*#__PURE__*/React.createElement("option", {
      value: "SA"
    }, "\uD83C\uDDF8\uD83C\uDDE6 Saudi Arabia"), /*#__PURE__*/React.createElement("option", {
      value: "SN"
    }, "\uD83C\uDDF8\uD83C\uDDF3 Senegal"), /*#__PURE__*/React.createElement("option", {
      value: "RS"
    }, "\uD83C\uDDF7\uD83C\uDDF8 Serbia"), /*#__PURE__*/React.createElement("option", {
      value: "SC"
    }, "\uD83C\uDDF8\uD83C\uDDE8 Seychelles"), /*#__PURE__*/React.createElement("option", {
      value: "SL"
    }, "\uD83C\uDDF8\uD83C\uDDF1 Sierra Leone"), /*#__PURE__*/React.createElement("option", {
      value: "SG"
    }, "\uD83C\uDDF8\uD83C\uDDEC Singapore"), /*#__PURE__*/React.createElement("option", {
      value: "SK"
    }, "\uD83C\uDDF8\uD83C\uDDF0 Slovakia"), /*#__PURE__*/React.createElement("option", {
      value: "SI"
    }, "\uD83C\uDDF8\uD83C\uDDEE Slovenia"), /*#__PURE__*/React.createElement("option", {
      value: "SB"
    }, "\uD83C\uDDF8\uD83C\uDDE7 Solomon Islands"), /*#__PURE__*/React.createElement("option", {
      value: "SO"
    }, "\uD83C\uDDF8\uD83C\uDDF4 Somalia"), /*#__PURE__*/React.createElement("option", {
      value: "ZA"
    }, "\uD83C\uDDFF\uD83C\uDDE6 South Africa"), /*#__PURE__*/React.createElement("option", {
      value: "KR"
    }, "\uD83C\uDDF0\uD83C\uDDF7 South Korea"), /*#__PURE__*/React.createElement("option", {
      value: "SS"
    }, "\uD83C\uDDF8\uD83C\uDDF8 South Sudan"), /*#__PURE__*/React.createElement("option", {
      value: "ES"
    }, "\uD83C\uDDEA\uD83C\uDDF8 Spain"), /*#__PURE__*/React.createElement("option", {
      value: "LK"
    }, "\uD83C\uDDF1\uD83C\uDDF0 Sri Lanka"), /*#__PURE__*/React.createElement("option", {
      value: "SD"
    }, "\uD83C\uDDF8\uD83C\uDDE9 Sudan"), /*#__PURE__*/React.createElement("option", {
      value: "SR"
    }, "\uD83C\uDDF8\uD83C\uDDF7 Suriname"), /*#__PURE__*/React.createElement("option", {
      value: "SE"
    }, "\uD83C\uDDF8\uD83C\uDDEA Sweden"), /*#__PURE__*/React.createElement("option", {
      value: "CH"
    }, "\uD83C\uDDE8\uD83C\uDDED Switzerland"), /*#__PURE__*/React.createElement("option", {
      value: "SY"
    }, "\uD83C\uDDF8\uD83C\uDDFE Syria"), /*#__PURE__*/React.createElement("option", {
      value: "TW"
    }, "\uD83C\uDDF9\uD83C\uDDFC Taiwan"), /*#__PURE__*/React.createElement("option", {
      value: "TJ"
    }, "\uD83C\uDDF9\uD83C\uDDEF Tajikistan"), /*#__PURE__*/React.createElement("option", {
      value: "TZ"
    }, "\uD83C\uDDF9\uD83C\uDDFF Tanzania"), /*#__PURE__*/React.createElement("option", {
      value: "TH"
    }, "\uD83C\uDDF9\uD83C\uDDED Thailand"), /*#__PURE__*/React.createElement("option", {
      value: "BS"
    }, "\uD83C\uDDE7\uD83C\uDDF8 The Bahamas"), /*#__PURE__*/React.createElement("option", {
      value: "GM"
    }, "\uD83C\uDDEC\uD83C\uDDF2 The Gambia"), /*#__PURE__*/React.createElement("option", {
      value: "TL"
    }, "\uD83C\uDDF9\uD83C\uDDF1 Timor-Leste"), /*#__PURE__*/React.createElement("option", {
      value: "TG"
    }, "\uD83C\uDDF9\uD83C\uDDEC Togo"), /*#__PURE__*/React.createElement("option", {
      value: "TK"
    }, "\uD83C\uDDF9\uD83C\uDDF0 Tokelau"), /*#__PURE__*/React.createElement("option", {
      value: "TO"
    }, "\uD83C\uDDF9\uD83C\uDDF4 Tonga"), /*#__PURE__*/React.createElement("option", {
      value: "TT"
    }, "\uD83C\uDDF9\uD83C\uDDF9 Trinidad and Tobago"), /*#__PURE__*/React.createElement("option", {
      value: "TN"
    }, "\uD83C\uDDF9\uD83C\uDDF3 Tunisia"), /*#__PURE__*/React.createElement("option", {
      value: "TR"
    }, "\uD83C\uDDF9\uD83C\uDDF7 Turkey"), /*#__PURE__*/React.createElement("option", {
      value: "TM"
    }, "\uD83C\uDDF9\uD83C\uDDF2 Turkmenistan"), /*#__PURE__*/React.createElement("option", {
      value: "TV"
    }, "\uD83C\uDDF9\uD83C\uDDFB Tuvalu"), /*#__PURE__*/React.createElement("option", {
      value: "TC"
    }, "\uD83C\uDDF9\uD83C\uDDE8 Turks and Caicos Islands"), /*#__PURE__*/React.createElement("option", {
      value: "UG"
    }, "\uD83C\uDDFA\uD83C\uDDEC Uganda"), /*#__PURE__*/React.createElement("option", {
      value: "UA"
    }, "\uD83C\uDDFA\uD83C\uDDE6 Ukraine"), /*#__PURE__*/React.createElement("option", {
      value: "AE"
    }, "\uD83C\uDDE6\uD83C\uDDEA United Arab Emirates"), /*#__PURE__*/React.createElement("option", {
      value: "UY"
    }, "\uD83C\uDDFA\uD83C\uDDFE Uruguay"), /*#__PURE__*/React.createElement("option", {
      value: "UZ"
    }, "\uD83C\uDDFA\uD83C\uDDFF Uzbekistan"), /*#__PURE__*/React.createElement("option", {
      value: "VU"
    }, "\uD83C\uDDFB\uD83C\uDDFA Vanuatu"), /*#__PURE__*/React.createElement("option", {
      value: "VA"
    }, "\uD83C\uDDFB\uD83C\uDDE6 Vatican City"), /*#__PURE__*/React.createElement("option", {
      value: "VE"
    }, "\uD83C\uDDFB\uD83C\uDDEA Venezuela"), /*#__PURE__*/React.createElement("option", {
      value: "VN"
    }, "\uD83C\uDDFB\uD83C\uDDF3 Vietnam"), /*#__PURE__*/React.createElement("option", {
      value: "WF"
    }, "\uD83C\uDDFC\uD83C\uDDEB Wallis and Futuna"), /*#__PURE__*/React.createElement("option", {
      value: "YE"
    }, "\uD83C\uDDFE\uD83C\uDDEA Yemen"), /*#__PURE__*/React.createElement("option", {
      value: "ZM"
    }, "\uD83C\uDDFF\uD83C\uDDF2 Zambia"), /*#__PURE__*/React.createElement("option", {
      value: "ZW"
    }, "\uD83C\uDDFF\uD83C\uDDFC Zimbabwe")), /*#__PURE__*/React.createElement("label", {
      className: "giveaway-form-label"
    }, /*#__PURE__*/React.createElement("input", {
      className: `${validPhone.valid ? 'giveaway-form-input' : 'invalid-input'}`,
      type: "text",
      name: "phone",
      placeholder: "*Phone",
      value: inputs.phone || "",
      onChange: handleChange
    })))), /*#__PURE__*/React.createElement("input", {
      className: 'submitButton',
      type: "submit"
    }), /*#__PURE__*/React.createElement("div", {
      className: "marketingDisclaimer"
    }, "By signing up via text, you agree to receive recurring automated marketing messages and shopping cart reminders at the phone number provided. Consent is not a condition of purchase. Reply STOP to unsubscribe. HELP for help. Msg frequency varies. Msg & Data rates may apply. View Privacy Policy & ToS"));
  }
}

// const notifyMeForm = document.getElementById('notify-me');
// const notifyMeWrapper = document.getElementById('notify-me-wrapper');
// if(notifyMeForm) {
//     const notifyMeFormRoot = ReactDOM.createRoot(notifyMeForm);
//     notifyMeFormRoot.render(<NotifyMeForm />);

//     notifyMeForm.addEventListener('click', (event) => {
//         event.stopPropagation();
//     });

//     notifyMeWrapper.addEventListener('click', () => {
//         console.log('clicked');
//         notifyMeWrapper.style.display= 'none';
//     });
// } else {
//     console.log('notify me form not found');
// }

const formHandler = id => {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', id]);
};
const notifyMeButton = document.getElementById('notify-me-button');
if (notifyMeButton) {
  notifyMeButton.addEventListener('click', () => {
    formHandler('WQzwD7');
  });
}
